document.addEventListener("DOMContentLoaded", () => {
  const EMBROIDERY_FEE_VARIANT_ID = 52417586626840;
  let syncingFee = false;

  const getCart = async () => {
    const response = await fetch(
      window.Shopify.routes.root + "cart.js",
      {
        headers: {
          Accept: "application/json"
        }
      }
    );

    if (!response.ok) {
      throw new Error("Could not read cart.");
    }

    return response.json();
  };

  const syncEmbroideryFee = async () => {
    if (syncingFee) return false;

    syncingFee = true;

    try {
      const cart = await getCart();

      const personalizedQuantity = cart.items.reduce((total, item) => {
        if (item.variant_id === EMBROIDERY_FEE_VARIANT_ID) {
          return total;
        }

        const properties = item.properties || {};

        const isPersonalized =
          Boolean(properties["_Thread Code"]) ||
          Boolean(
            properties["Personalization"] &&
            properties["Font"] &&
            properties["Thread Color"]
          );

        return isPersonalized
          ? total + item.quantity
          : total;
      }, 0);

      const feeLine = cart.items.find(
        (item) => item.variant_id === EMBROIDERY_FEE_VARIANT_ID
      );

      const currentFeeQuantity = feeLine
        ? feeLine.quantity
        : 0;

      if (currentFeeQuantity === personalizedQuantity) {
        return false;
      }

      if (feeLine) {
        const response = await fetch(
          window.Shopify.routes.root + "cart/change.js",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json"
            },
            body: JSON.stringify({
              id: feeLine.key,
              quantity: personalizedQuantity
            })
          }
        );

        if (!response.ok) {
          throw new Error("Could not update embroidery fee.");
        }
      } else if (personalizedQuantity > 0) {
        const response = await fetch(
          window.Shopify.routes.root + "cart/add.js",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json"
            },
            body: JSON.stringify({
              items: [
                {
                  id: EMBROIDERY_FEE_VARIANT_ID,
                  quantity: personalizedQuantity
                }
              ]
            })
          }
        );

        if (!response.ok) {
          throw new Error("Could not add embroidery fee.");
        }
      }

      return true;
    } catch (error) {
      console.error(
        "Fin & Fern embroidery fee sync error:",
        error
      );

      return false;
    } finally {
      syncingFee = false;
    }
  };

  const syncAndRefreshCartPage = async () => {
    const changed = await syncEmbroideryFee();

    if (
      changed &&
      window.location.pathname.replace(/\/$/, "") === "/cart"
    ) {
      window.location.reload();
    }
  };

  document.addEventListener(
    "shopify:cart:lines-update",
    syncAndRefreshCartPage
  );

  document.addEventListener(
    "shopify:cart:view",
    syncAndRefreshCartPage
  );

  syncAndRefreshCartPage();
  if (
  typeof subscribe === "function" &&
  typeof PUB_SUB_EVENTS !== "undefined"
) {
  subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
    const changed = await syncEmbroideryFee();

    if (
      changed &&
      window.location.pathname.replace(/\/$/, "") === "/cart"
    ) {
      window.location.reload();
    }
  });
}
});